import { render, staticRenderFns } from "./reviewCard.vue?vue&type=template&id=1a78b370&scoped=true&"
import script from "./reviewCard.vue?vue&type=script&lang=js&"
export * from "./reviewCard.vue?vue&type=script&lang=js&"
import style0 from "./reviewCard.vue?vue&type=style&index=0&id=1a78b370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78b370",
  null
  
)

export default component.exports